import * as React from 'react';

// Types
import { ISurveyFull, SurveyStatus } from '../types';

export const useRejectionQuestionHighlights = (survey: ISurveyFull, options?: { removeAsAdjusted?: boolean }) => {
    const highlights = React.useMemo(() => {
        if (!survey?.notes || ![SurveyStatus.REJECTED, SurveyStatus.IN_PROGRESS].includes(survey.status)) return [];
        const latestNote = survey?.notes.sort((a, b) => +new Date(b.updatedAt) - +new Date(a.updatedAt))?.[0];

        if (latestNote && latestNote.type === 'REJECT' && latestNote?.dataRelation?.type === 'SURVEY_QUESTIONS') {
            return latestNote?.dataRelation?.data as string[];
        } else {
            return [];
        }
    }, [survey]);

    return highlights;
};

export default useRejectionQuestionHighlights;
